export default {
    movies: {
        veryHard: [    
            'jaws', 'et', 'coco', 'hulk', 'thor', 'xmen', 'fury', 'up', 'hair', 'saw'
        ],
        hard: [
            'alien', 'titanic', 'psycho', 'rocky', 'avatar', 'moana', 'aladdin', 'mulan', 
            'click', 'creed', 'frozen', 'aquaman', 'ice age', 'venom', 'shrek', 'grease', 
            'bambi', 'twister', 'rambo', 'taken', 'borat', 'hot rod'
        ],
        medium: [
            'la la land', 'whiplash', 'godfather', 'star wars', 'casablanca', 
            'the matrix', 'goodfellas', 'fight club', 'inception', 'snow white', 
            'cinderella', 'toy story', 'booksmart', 'lion king', 'die hard', 'spiderman', 
            'iron man', 'deadpool', 'the room', 'zootopia', 'home alone', 'godzilla', 
            'king kong', 'peter pan', 'rush hour', 'liar liar', 'magic mike', 
            'happy feet', 'the ring', 'halloween', 'sin city', 'space jam', 'surfs up'
        ],
        easy: [
            'lord of the rings', 'the dark knight', 'pulp fiction', 'inglorious bastards',
            'forrest gump', 'jurassic park', 'back to the future', 
            'the shawshank redemption', 'schindlers list', 'the departed', 
            'silence of the lambs', 'the wizard of oz', 'the exorcist', 'the avengers',
            'scott pilgrim vs the world', 'baby driver', 'infinity war', 'captain america',
            'captain marvel', 'guardians of the galaxy', 'fantastic four', 
            'the spongebob movie', 'the waterboy', 'benchwarmers', 'black panther', 
            'doctor strange', 'pirates of the carribean', 
            'willy wonka and the chocolate factory', 'a bronx tale', 'harry potter',
            'fast and furious', 'beauty and the beast', 'the incredibles', 'wonder woman',
            'finding nemo', 'the twilight saga', 'mission impossible', 
            'the chronicles of narnia', 'independence day', 'transformers', 
            'suicide squad', 'alice in wonderland', 'the passion of christ', 
            'the greatest showman', 'mary poppins', 'ghostbusters', 'west side story',
            'the breakfast club', 'men in black', 'the jungle book', 'beverly hills cop',
            'saving private ryan', 'how the grinch stole christmas', 
            'pokemon the first movie', 'the polar express', 'dumb and dumber', 
            'ace venture pet detective', 'horrible bosses', 'the hangover', 'bridesmaids',
            'bruce almighty', 'austin powers', 'dirty dancing', 'marley and me', 
            'the blair witch project', 'i am legend', 'world war z',  
            'straight out of compton', 'who framed roger rabbit', 'blades of glory',
            'kicking and screaming', 'blade runner', 'the great gatsby', 'the revenant',
            'the notebook', 'the never ending story', 'the outsiders', 'the shining',
            'stand by me'
        ]
    },
    games: {
        veryHard: [
            'gta', 'halo', 'dota', 'fifa', 'doom'
        ],
        hard: [ 
            'witcher', 'pokemon', 'yugioh', 'tetris', 'destiny', 'skyrim', 'fallout', 
            'diablo', 'madden',  'frogger', 'metroid', 'tekken', 'contra', 'persona',
            'fornite', 'pacman', 'portal'
        ],
        medium: [
            'spiderman', 'last of us', 'the sims', 'mario kart', 'star fox', 'sly cooper',
            'starcraft', 'minecraft', 'wii sports', 'undertale', 'mega man', 'goldeneye',
            'donky kong', 'rock band', 'uncharted', 'overwatch', 'dark souls', 
            'bloodborne', 'god of war', 'bioshock', 'half life'
        ],
        easy: [
            'call of duty', 'final fantasy', 'kingdom hearts', 'super smash brothers',
            'mario party', 'super mario world', 'crash bandicoot', 'banjo kazooie',
            'luigis mansion', 'mass effect', 'rainbow six', 'counter strike',
            'league of legends', 'world of warcraft', 'civilization', 
            'red dead redemption', 'sonic the hedgehog', 'borderlands', 'metal gear solid',
            'assassins creed', 'castlevania', 'soul caliber', 'mortal kombat',
            'tony hawks pro skater', 'resident evil', 'apex legends', 'battlefield',
            'silent hill', 'batman arkham asylum', 'shadow of the colossus', 
            'the legend of zelda', 'chrono trigger', 'street fighter'
        ]
    },
    books: {
        veryHard: [
            'it', 'dune', 'bfg'
        ],
        hard: [
            'carrie', 'macbeth', 'hamlet', 'othello', 'eragon', 'i robot', 'dracula', 
            'witcher'
        ],
        medium: [
            'moby dick', 'the giver', 'nancy drew', 'twilight', 'jane eyre', 'animorphs',
            'the raven', 'warriors'
        ],
        easy: [
            'hunger games', 'to kill a mocking bird', 'the adventures of tom sawyer',
            'romeo and juliet', 'gone with the wind', 'the da vinci code', 
            'a tale of two cities', 'harry potter', 'the very hungry caterpillar',
            'fifty shades of grey', 'the handmaids tale', 'and then there were none',
            'lord of the flies', 'the great gatsby', 'the fault in our stars', 
            'animal farm', 'pride and prejudice', 'where the wild things are',
            'the power of positive thinking', 'the outsiders', 'the grapes of wrath', 
            'the hitchikers guide to the galaxy', 'a wrinkle in time', 
            'the cat in the hat', 'diary of a wimpy kid', 'the chronicles of narnia',
            'a song of ice and fire', 'captain underpants', 
            'a series of unfortunate events', 'the dark tower', 'the shining', 
            'the catcher in the rye', 'of mice and men', 
            'the adventures of huckleberry finn', 'the odyssey', 'julius caeser', 
            'crime and punishment', 'frankenstein', 'enders game', 'gullivers travels', 
            'les miserables', 'the metamorphosis', 'where the crawdads sing', 
            'green eggs and ham', 'becoming michelle obama', 
            'war against all puerto ricans', 'left to tell', 'rocket boys', 
            'everything on it', 'down these mean streets', 
            'percy jackson and the olympians', 'a shadow of what was lost', 
            'the haunting of hill house', 'treasure island', 'the art of war', 
            'don quixote', 'the old man and the sea', 'for whom the bell tolls', 
            "charlotte's web", 'a christmas carol', 'necronomicon', 'pet sematary', 
            'ready player one', 'the martian'
        ]
    },
    tvShows: {
        veryHard: [
            'mash', 'lost', 'er'
        ],
        hard: [
            'friends', 'mad men', 'cheers', 'frasier', 'dexter', 'icarly', 'pokemon', 
            'digimon', 'yugioh', 'naruto', 'bleach', 'atlanta', 'archer', 'frasier'
        ],
        medium: [
            'the wire', 'family guy', 'seinfeld', 'the office', 'south park', 
            'portlandia', 'twin peaks', 'daredevil', 'luke cage', 'the middle', 
            'doctor who', 'spongebob', 'victorious', 'one piece', 'scooby doo', 
            'homeland', 'hannibal', 'survivor', 'all that', 'star trek', 'futurama'
        ],
        easy: [
            'game of thrones', 'breaking bad', 'the sopranos', 'the simpsons', 
            'parks and recreation', 'arrested development', 'saturday night live',
            'the walking dead', 'the big bang theory', 'curb your enthusiam', 
            'the x files', 'i love lucy', 'buffy the vampire slayer', 'the twilight zone',
            'black mirror', 'stranger things', 'on my block', 'modern family', 
            'orange is the new black', 'freaks and geeks', 'bojack horseman', 
            'sex and the city', 'ren and stimpy', 'beavis and butthead', 'robot chicken',
            'dragon ball z', 'the fresh prince of bel air', 'malcolm in the middle',
            'law and order', 'chappelles show', 'downtown abbey', 'american horror story',
            'the jetsons', 'the flinstones', 'house of cards', 'key and peele', 
            'the golden girls', 'prison break', 'true detective', 
            'avatar the last airbender', 'boardwalk empire', 'rick and morty', 
            'greys anatomy', 'the andy griffith show', 'the honeymooners', 
            'the muppet show', 'cowboy bebop', 'in living color', 
            'mister rogers neighborhood', 'blues clues', 'teletubbies', 
            'dora the explorer', 'band of brothers', 'sesame street', 
            'everybody loves raymond', 'everybody hates chris', 'home improvement'
        ]
    },
    musicArtists: {
        veryHard: [    
            'kyle', 'jay z','pink', 'rush', 'joji', 'nwa', 'jid', 'neyo'
        ],
        hard: [
            'eminem', 'madonna', 'drake', 'prince', 'beyonce', 'rihanna', 'tupac', 
            'adele', 'nirvana', 'j cole', 'nsync', 'kehlani', 'logic', 't pain', 'amine',
            'miguel', 'big pun', 'ciara', 'khalid', 'nelly', 'queen', 'usher', 'weezer'
        ],
        medium: [
            'lady gaga', 'elton john', 'lil wayne', 'billy joel', 'ed sheeran', 
            'kanye west', 'katy perry', 'bruno mars', 'bad bunny', 'nial horan', 
            'zayn malik', 'liam payne', 'skrillex', 'dua lipa', 'rich brian', 
            'asap rocky', 'asap ferg', 'the doors', 'green day', 'marshmello', 
            'mac miller', 'paramore', 'radiohead', 'young thug'
        ],
        easy: [
            'guns n roses', 'michael jackson', 'ßelvis presley', 'bruce springsteen',
            'taylow swift', 'selena gomez', 'mariah carey', 'whitney houston',
            'stevie wonder', 'david bowie', 'britney spears', 'paul mccartney', 
            'the beatles', 'celine dion', 'justin bieber', 'biggie smalls', 
            'frank sinatra', 'jimi hendrix', 'foo fighters', 'my chemical romance',
            'john lennon', 'james brown', 'ozzy osbourne', 'carlos santana', 
            'fall out boy', 'brockhampton', 'xxxtentacion', 'anderson paak',
            'justin timberlake', 'boys n the hood', 'boyz ii men', 'one direction',
            'harry styles', 'louis tomlinson', 'a boogie wit da hoodie', 
            'red hot chili peppers', 'system of a down', 'jennifer lopez', 'nicki minaj',
            'schoolboy q', 'kendrick lamar', 'tyler the creator', 'frank ocean', 
            'all time low', 'the all american rejects', 'talib kweli', 'backstreet boys',
            'joey badass', 'bill withers', 'billie eilish', 'chance the rapper', 
            'childish gambino', 'missy elliot', 'earth wind and fire', 'jaden smith', 
            'jonas brothers', 'wiz khalifa', 'linkin park', 'marc anthony', 
            'pharell williams', 'panic at the disco', 'playboi carti', 'post malone',
            'shawn mendes', 'travis scott'
        ]
    },
    misc: {
        veryHard: [
            "able", "acid", "arch", "army", "baby", "back", "ball", "band", "base", 
            "bath", "bell", "bent", "bird", "bite", "blow", "blue", "boat", "body", 
            "bone", "book", "boot", "bulb", "burn", "cake", "card", "care", "cart", 
            "chin", "coal", "coat", "cold", "comb", "come", "copy", "cord", "cork", 
            "dark", "dead", "dear", "debt", "deep", "door", "down", "drop", "dust", 
            "east", "edge", "even", "ever", "face", "fact", "fall", "farm", "fear", 
            "fire", "fish", "flag", "flat", "fold", "food", "foot", "fork", "form", 
            "fowl", "free", "from", "full", "girl", "give", "goat", "gold", "good", 
            "grey", "grip", "hair", "hand", "hard", "hate", "have", "head", "hear",
            'heat', 'help', 'high', 'hole', 'hook', 'hope', 'horn', 'hour', 'idea', 
            'iron', 'join', 'jump', 'keep', 'kick', 'kind', 'kiss', 'knee', 'knot', 
            'land', 'last', 'late', 'lead', 'leaf', 'left', 'lift', 'like', 'line', 
            'list', 'lock', 'long', 'look', 'loss', 'loud', 'love', 'make', 'male', 
            'mark', 'mass', 'meal', 'meat', 'milk', 'mind', 'mine', 'mist', 'moon', 
            'move', 'much', 'nail', 'name', 'near', 'neck', 'need', 'news', 'nose', 
            'note', 'only', 'open', 'oven', 'over', 'page', 'pain', 'part', 'past', 
            'pipe', 'play', 'poor', 'pull', 'pump', 'push', 'rail', 'rain', 'rate', 
            'rest', 'rice', 'ring', 'road', 'roll', 'roof', 'room', 'root', 'rule', 
            'safe', 'sail', 'salt', 'same', 'sand', 'seat', 'seed', 'seem', 'self', 
            'send', 'ship', 'shoe', 'shut', 'side', 'sign', 'silk', 'size', 'skin', 
            'slip', 'slow', 'snow', 'soap', 'sock', 'soft', 'some', 'song', 'sort', 
            'soup', 'star', 'stem', 'step', 'stop', 'such', 'swim', 'tail', 'take', 
            'talk', 'tall', 'test', 'than', 'that', 'then', 'thin', 'this', 'till', 
            'time', 'town', 'tray', 'tree', 'true', 'turn', 'unit', 'very', 'view', 
            'walk', 'wall', 'warm', 'wash', 'wave', 'week', 'well', 'west', 'when', 
            'whip', 'wide', 'will', 'wind', 'wine', 'wing', 'wire', 'wise', 'with', 
            'wood', 'wool', 'word', 'work', 'worm', 'year'
        ],
        hard: [
            "about", "account", "across", "after", "again", "against", "almost", "among", 
            "amount", "angle", "angry", "animal", "answer", "apple", 'attack', 'attempt', 
            'awake', 'balance', 'basin', 'basket', 'because', 'before', 'belief', 'berry', 
            'between', 'birth', 'bitter', 'black', 'blade', 'blood', 'board', 'boiling', 
            'bottle', 'brain', 'brake', 'branch', 'brass', 'bread', 'breath', 'brick', 
            'bridge', 'bright', 'broken', 'brother', 'brown', 'brush', 'bucket', 'burst', 
            'butter', 'button', 'camera', 'canvas', 'cause', 'certain', 'chain', 'chalk', 
            'chance', 'change', 'cheap', 'cheese', 'chest', 'chief', 'church', 'circle', 
            'clean', 'clear', 'clock', 'cloth', 'cloud', 'collar', 'colour', 'comfort', 
            'common', 'company', 'complex', 'control', 'copper', 'cotton', 'cough', 
            'country', 'cover', 'crack', 'credit', 'crime', 'cruel', 'crush', 'current', 
            'curtain', 'curve', 'cushion', 'damage', 'danger', 'death', 'degree', 'design', 
            'desire', 'detail', 'dirty', 'disease', 'disgust', 'doubt', 'drain', 'drawer', 
            'dress', 'drink', 'driving', 'early', 'earth', 'effect', 'elastic', 'engine', 
            'enough', 'equal', 'error', 'event', 'every', 'example', 'expert', 'false', 
            'family', 'father', 'feather', 'feeble', 'feeling', 'female', 'fertile', 
            'fiction', 'field', 'fight', 'finger', 'first', 'fixed', 'flame', 'flight', 
            'floor', 'flower', 'foolish', 'force', 'forward', 'frame', 'friend', 'front', 
            'fruit', 'future', 'garden', 'general', 'glass', 'glove', 'grain', 'grass', 
            'great', 'green', 'group', 'growth', 'guide', 'hammer', 'hanging', 'happy', 
            'harbour', 'harmony', 'healthy', 'hearing', 'heart', 'history', 'hollow', 
            'horse', 'house', 'humour', 'impulse', 'insect', 'island', 'jelly', 'jewel', 
            'journey', 'judge', 'kettle', 'knife', 'laugh', 'leather', 'letter', 'level', 
            'library', 'light', 'limit', 'linen', 'liquid', 'little', 'living', 'loose', 
            'machine', 'manager', 'market', 'married', 'match', 'measure', 'medical', 
            'meeting', 'memory', 'metal', 'middle', 'minute', 'mixed', 'money', 'monkey', 
            'month', 'morning', 'mother', 'motion', 'mouth', 'muscle', 'music', 'narrow', 
            'nation', 'natural', 'needle', 'nerve', 'night', 'noise', 'normal', 'north', 
            'number', 'offer', 'office', 'opinion', 'orange', 'order', 'other', 'owner', 
            'paint', 'paper', 'parcel', 'paste', 'payment', 'peace', 'pencil', 'person', 
            'picture', 'place', 'plane', 'plant', 'plate', 'please', 'plough', 'pocket', 
            'point', 'poison', 'polish', 'porter', 'potato', 'powder', 'power', 'present', 
            'price', 'print', 'prison', 'private', 'process', 'produce', 'profit', 'prose', 
            'protest', 'public', 'purpose', 'quality', 'quick', 'quiet', 'quite', 'range', 
            'reading', 'ready', 'reason', 'receipt', 'record', 'regret', 'regular', 
            'request', 'respect', 'reward', 'rhythm', 'right', 'river', 'rough', 
            'round', 'scale', 'school', 'science', 'screw', 'second', 'secret', 'sense', 
            'serious', 'servant', 'shade', 'shake', 'shame', 'sharp', 'sheep', 'shelf', 
            'shirt', 'shock', 'short', 'silver', 'simple', 'sister', 'skirt', 'sleep',
            'slope', 'small', 'smash', 'smell', 'smile', 'smoke', 'smooth', 'snake',
            'sneeze', 'society', 'solid', 'sound', 'south', 'space', 'spade', 'special', 
            'sponge', 'spoon', 'spring', 'square', 'stage', 'stamp', 'start', 'station', 
            'steam', 'steel', 'stick', 'sticky', 'stiff', 'still', 'stitch', 'stomach', 
            'stone', 'store', 'story', 'strange', 'street', 'stretch', 'strong', 'sudden', 
            'sugar', 'summer', 'support', 'sweet', 'system', 'table', 'taste', 'theory', 
            'there', 'thick', 'thing', 'thought', 'thread', 'throat', 'through', 
            'through', 'thumb', 'thunder', 'ticket', 'tight', 'tired', 'tongue', 'tooth', 
            'touch', 'trade', 'train', 'trick', 'trouble', 'twist', 'under', 'value', 
            'verse', 'vessel', 'violent', 'voice', 'waiting', 'waste', 'watch', 'water', 
            'weather', 'weight', 'wheel', 'where', 'while', 'whistle', 'white', 'window', 
            'winter', 'woman', 'wound', 'writing', 'wrong', 'yellow', 'young'
        ],
        medium: [
            "addition", "adjustment", "agreement", "amusement", "apparatus", "approval", 
            'argument', 'attention', 'attraction', 'authority', 'automatic', 'beautiful', 
            'behaviour', 'building', 'business', 'carriage', 'chemical', 'committee', 
            'comparison', 'complete', 'condition', 'connection', 'conscious', 'daughter', 
            'decision', 'delicate', 'dependent', 'different', 'digestion', 'direction', 
            'discovery', 'discussion', 'distance', 'division', 'education', 'electric', 
            'exchange',  'existence', 'expansion', 'experience', 'frequent', 'government', 
            'hospital', 'important', 'increase', 'industry', 'instrument', 'insurance', 
            'interest', 'invention', 'knowledge', 'language', 'learning', 'material', 
            'military', 'mountain', 'necessary', 'operation', 'opposite', 'ornament', 
            'parallel', 'physical', 'pleasure', 'political', 'position', 'possible', 
            'probable', 'property', 'punishment', 'question', 'reaction', 'relation', 
            'religion', 'scissors', 'secretary', 'selection', 'separate', 'statement', 
            'stocking', 'straight', 'structure', 'substance', 'suggestion', 'surprise', 
            'teaching', 'tendency', 'together', 'tomorrow', 'transport', 'trousers', 
            'umbrella', 'yesterday'
        ],
        easy: [
            "advertisement", 'competition', 'destruction', 'development', 
            'distribution', 'observation', 'organization', 'representative', 'responsible'
        ]
    }
}